const initialstate = {
  data:[],
  DataView:[],
  adddata:[],
  imgdata:[],
  editdat:[],
  Deletedata:[]
}

const OrgDocumentsReducers =  (state = initialstate, action:any)=>{
  switch (action.type){
      case 'fetch_data_success':
          return {... state, data:action.payload};
          case 'fetch_view_data_success':
            return{ ...state, DataView: action.payload }
            case 'FETCH_ADD_DATA_SUCCESS':
           return{ ...state, adddata: action.payload }
           case 'FETCH_ADD_DATA_SUCCESS_file':
             return{ ...state, imgdata:action.payload}
             case 'FETCH_EDIT_DATA_SUCCESS_file':
              return{ ...state,editdat:action.payload}
           case 'DELETE_DATA_SUCCESS':
            return { ...state, Deletedata: action.payload };
          default:
            return state;
  }
};
export default OrgDocumentsReducers;

